export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '馆名',
      width: 200,
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '等级',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'scoretotal',
      dataIndex: 'scoretotal',
      title: '总得分',
    },
    {
      key: 'scoresub',
      dataIndex: 'scoresub',
      title: '减分',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '操作',

      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData1 = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '减分项',
      width: 200
    },
    {
      key: 'extraid',
      dataIndex: 'extraid',
      title: '关联指标',
    },
    {
      key: 'scoresub',
      dataIndex: 'scoresub',
      title: '减分值',
    },
    {
      key: 'expertlist',
      dataIndex: 'expertlist',
      title: '建议减分专家',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '操作',
      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
